export default __webpack_public_path__ + "static/media/Leather-Toys-Making.7f770968.jpg";